import type { AdvertisingPlatform, AdvertisingPlatformDTO } from '../model/types'
import type { CreateAdvertisingPlatformArgs, CreateAdvertisingPlatformArgsDTO } from './types'

export const mapAdvertisingPlatformFromDTO = ({ id, name, visible }: AdvertisingPlatformDTO): AdvertisingPlatform => ({
    id,
    name,
    visible
})

export const mapAdvertisingPlatformToDTO = ({
    name,
    visible,
    partnerId
}: CreateAdvertisingPlatformArgs): CreateAdvertisingPlatformArgsDTO => ({
    name,
    visible,
    partner_id: partnerId
})
